import React, { useMemo, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import { resolveBookingInvoiceNumber } from '../../utils/bookingInvoiceNumber';
import BookingInvoicePreviewDialog from './BookingInvoicePreviewDialog';

export default function PaymentDrawerHeaderTitle({
  title = 'Payment',
  booking,
  bookingId,
  paymentHistory = [],
  isDark,
  drawerTheme,
  accentColor,
}) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const invoiceId = resolveBookingInvoiceNumber(booking, paymentHistory);
  const titleColor = isDark ? drawerTheme?.text : '#333';
  const subtleColor = drawerTheme?.subtleText || (isDark ? '#999' : '#666');

  const resolvedBookingId = useMemo(
    () => bookingId ?? booking?.id ?? booking?.booking_id ?? null,
    [booking, bookingId]
  );

  const bookingCode = booking?.code || booking?.booking_code || null;
  const guestName = booking?.guest_name || booking?.guest?.name || null;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <PaymentIcon sx={{ color: accentColor, fontSize: 24 }} />
        <Typography variant="h6" sx={{ color: titleColor, fontWeight: 600 }}>
          {title}
        </Typography>
        {invoiceId && resolvedBookingId ? (
          <>
            <Typography variant="body2" sx={{ color: subtleColor, mx: 0.25 }}>
              -
            </Typography>
            <Chip
              clickable
              label={invoiceId}
              size="small"
              onClick={() => setPreviewOpen(true)}
              sx={{
                backgroundColor: accentColor,
                color: '#000',
                fontWeight: 700,
                fontSize: '0.75rem',
                height: 24,
                letterSpacing: '0.01em',
                '&:hover': {
                  backgroundColor: accentColor,
                  filter: 'brightness(0.95)',
                },
              }}
            />
          </>
        ) : null}
      </Box>

      <BookingInvoicePreviewDialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        bookingId={resolvedBookingId}
        invoiceNumber={invoiceId}
        bookingCode={bookingCode}
        guestName={guestName}
        isDark={isDark}
        accentColor={accentColor}
      />
    </>
  );
}
